export default "__VITE_ASSET__PQssygzv__"